import { AbstractDataProviderV2, adapter } from 'components/system';
import { RsCustomerInterest } from 'common/customers/services/types/RsCustomerInterest';
import { CustomerInterestAdd } from 'common/customers/services/types/CustomerInterestAdd';
import { CustomerInterestUpdate } from 'common/customers/services/types/CustomerInterestUpdate';
import { RsCustomerInterestInfo } from 'common/customers/services/types/RsCustomerInterestInfo';

export class CustomerInterestDataProvider extends AbstractDataProviderV2<
    RsCustomerInterest,
    RsCustomerInterestInfo,
    CustomerInterestAdd,
    CustomerInterestUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/interests');
    }

    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
}
